<template>
    <div class="d-inline-flex">
        <v-btn
            :color="color"
            :small="small"
            :dark="!outlined"
            :outlined="outlined"
            :disabled="disabled || loading"
            :loading="loading"
            class="action-menu-primary"
            @click="triggerPrimaryAction"
        >
            <v-icon v-if="actions[0]?.icon" class="mr-1">{{
                actions[0].icon
            }}</v-icon>
            {{ actions[0]?.label }}
        </v-btn>
        <v-menu
            v-if="actions.length > 1"
            content-class="compact-action-menu"
            offset-y
            right
            v-model="menu"
            transition="scale-transition"
            :nudge-bottom="5"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :color="color"
                    :small="small"
                    :dark="!outlined"
                    :outlined="outlined"
                    :disabled="disabled || loading"
                    :aria-label="menuLabel"
                    class="action-menu-chevron px-0"
                    min-width="40"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                    v-for="(item, index) in actions"
                    :key="index"
                    @click="onAction(item)"
                >
                    <template v-if="item.icon">
                        <v-list-item-icon>
                            <v-icon :color="item.color">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                    </template>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "ActionMenu",
    props: {
        small: Boolean,
        outlined: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        menuLabel: { type: String, default: "Actions" },
        actions: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            default: "primary",
        },
    },
    data() {
        return {
            menu: false,
        };
    },
    methods: {
        triggerPrimaryAction() {
            if (!this.disabled && !this.loading && this.actions.length > 0) {
                this.onAction(this.actions[0]);
            }
        },
        onAction(item) {
            if (this.disabled || this.loading) { return; }
            this.$emit(item.action, item);
            this.menu = false;
        },
    },
};
</script>

<style scoped>
.action-menu-primary {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.action-menu-chevron {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left: 1px solid rgba(255, 255, 255, 0.4) !important;
    min-width: 40px !important;
    flex: 0 0 40px;
}
</style>

<style lang="scss">
.compact-action-menu {
    .v-list { padding: 4px; }
    .v-list-item { min-height: 32px; padding: 0 10px; font-size: 12px; }
    .v-list-item__content { padding: 6px 0; }
    .v-list-item__title { font-size: 13px !important; line-height: 1.4; }
    .v-list-item__icon { margin: 6px 10px 6px 0 !important; min-width: 18px; }
    .v-icon { font-size: 18px; }
}
</style>

<style scoped>
.v-btn--size-small, .v-btn--is-elevated.v-size--small, .v-btn.v-size--small { font-size: 12px; letter-spacing: normal; text-transform: none; }
</style>
